import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages =   {
  fr: {
    seeking: {
      label: 'Quelles informations recherchez vous ?',
      pronostics: 'Des pronostics clé en main',
      advices: 'Des Conseils de Jeux et Tuyaux',
      infotools: 'Des détails sur les partants / statistiques ou outils',
      learn: 'Apprendre à mieux jouer'
    },
    favoriteMedia: {
      label: "Comment préférez vous consulter / recevoir les informations et conseils ?",
      sms: "SMS",
      phone: "Téléphone / boite vocale",
      email: "Email",
      web: "En ligne sur un Site Web",
      paper: "Journal Papier acheté ou Imprimé",
    },
    firstTime: {
      label: "Quand avez vous effectué votre premier pari ?",
      never: "jamais",
      weeks: "il y a moins d'un mois",
      months: "il y a quelques mois",
      years: "il y a quelques années"

    },
    operator: {
      label: "Quel(s) opérateur(s) utilisez vous pour jouer ?",
      pmuOffline: "Point de vente PMU",
      pmuOnline: "PMU sur internet",
      zeturf: "Zeturf",
      betclic: "Betclic",
      genybet: "GenyBet",
      leturf: "Leturf",
      other: "Autre"
    },
    objective: {
      label: "Vous jouez pour ?",
      jackpot: "Gagner le gros lot",
      yield: "Un rendement sur le long terme",
      fun: "Le plaisir de jouer"
    },
    technics: {
      label: "Connaissez vous les techniques suivantes ?",
      montantes: "Montantes / Martingales",
        champs: "Champs réduits / total",
      combinaison:  "Jeux combinés",
      repartition: "Répartition de mise",
      gap: "Gestion des écarts"
    },
    budget: {
      label: "Quel est votre budget jeu sur 1 journée ?",
      lt10: "Moins de 10€",
      '10to20': "entre 10 et 20€",
      '20to50': "entre 20 et 50€",
      '50to100': "entre 50 et 100€",
      'gt100': "Plus de 100€"

    }
  },
}

export default new VueI18n({
  locale: 'fr',
  messages

}
)
